class About extends HTMLElement {
  connectedCallback() {
    this.render();
    this._handlerDarkMode();
  }

  render() {
    this.innerHTML = `
      <article class="w-11/12 lg:w-3/5 mt-8 mb-20 md:mb-24 m-auto">
        <section class="mb-12">
          <div class="section-title-container">
            <h2 class="section-title" tabindex="0">Al-Quran Mahabbah</h2>
          </div>
          <p class="text-lg pb-3 text-justify" tabindex="0">
            Al-Quran Mahabbah merupakan Al-Quran berbasis digital. Dengan hadirnya Al-Quran Mahabbah, kami berharap dapat memudahkan Anda dalam membaca, mendengarkan, serta memahami Al-Quran. Tersedia pula beberapa versi tafsir yang dapat membantu Anda dalam memahami isi Al-Quran.
          </p>
          <div id="hadith-container" class="bg-slate-100 rounded-md p-4 mb-3 text-justify">
            <p class="text-lg pb-2" tabindex="0">
              Nabi Muhammad shallallahu 'alaihi wa sallam bersabda,
            </p>
            <p class="text-arabic text-2xl text-end pb-2" tabindex="0">
              تَرَكْتُ فِيْكُمْ أَمْرَيْنِ لَنْ تَضِلُّوْا مَا تَمَسَّكْتُمْ بِهِمَا : كِتَابَ اللهِ وَ سُنَّةَ رَسُوْلِهِ
            </p>
            <q class="text-lg italic pb-2" tabindex="0">
              Aku telah tinggalkan kepada kamu dua perkara. Kamu tidak akan sesat selama berpegang kepada keduanya, (yaitu) Kitab Allah dan Sunnah Rasul-Nya.
            </q>
            <p tabindex="0">
              (HR. Malik; Al-Hakim, Al-Baihaqi, Ibnu Nashr, Ibnu Hazm. Hadits ini disahihkan oleh Syaikh Salim Al-Hilali di dalam At-Ta'zhim wa Al-Minnah fi Al-Intishar As-Sunnah, hlm. 12-13).
            </p>
          </div>
          <p class="text-lg pb-3 text-justify" tabindex="0">
            Semoga Al-Quran Mahabbah dapat mempermudahkan kita dalam upaya mendekatkan diri kepada Allah SWT dan cinta dengan Al-Quran. Kami juga berwasiat agar senantiasa bertawakal kepada Allah SWT, mengerjakan segala perintahnya dan menjauhi segala larangannya.
          </p>
          <p class="text-lg" tabindex="0">
            Beberapa fitur Al-Quran Mahabbah (versi 1.0):
          </p>
          <ul class="ms-8 md:ms-12 list-disc text-lg">
            <li tabindex="0">Terjemahan bahasa Indonesia</li>
            <li tabindex="0">Tentang surah</li>
            <li tabindex="0">Rekomendasi surah</li>
            <li tabindex="0">Audio murottal per surah</li>
            <li tabindex="0">4 versi tafsir per ayat</li>
            <li tabindex="0">6 versi audio murottal per ayat</li>
            <li tabindex="0">Simpan ayat</li>
            <li tabindex="0">Salin ayat</li>
            <li tabindex="0">Tandai ayat sebagai terakhir dibaca</li>
            <li tabindex="0">Navigasi surah dan ayat</li>
            <li tabindex="0">Al-Quran Mahabbah dapat diinstal</li>
            <li tabindex="0">Mendukung mode gelap</li>
          </ul>
        </section>

        <section class="mb-12">
          <div class="section-title-container">
            <h2 class="section-title" tabindex="0">Tim Development</h2>
          </div>
          <picture>
            <source srcset="./images/dev-ardi-small.webp" type="image/webp" media="(max-width: 600px)">
            <source srcset="./images/dev-ardi-small.jpg" type="image/jpeg" media="(max-width: 600px)">
            <source srcset="./images/dev-ardi-large.webp" type="image/webp">
            <img class="w-52 shadow-xl border border-white rounded-full mx-auto mb-4" src="./images/dev-ardi-large.jpg" alt="Developer Ardi" tabindex="0">
          </picture>
          <p class="text-xl md:text-2xl font-bold text-center text-[#35A29F] underline mb-1" tabindex="0">Fullstack Developer</p>
          <p class="text-xl md:text-2xl font-bold text-center" tabindex="0">Ardi Saputra</p>
          <div class="section-body-container mt-4">
            <a href="https://wa.me/6282274022132?text=Al-Quran%20Mahabbah" class="w-11 mx-4">
              <img src="./icons/whatsapp-icon.svg" alt="whatsapp icon">
            </a>
            <a href="https://ardisaputra-portfolio.vercel.app" class="w-11 mx-4">
              <img src="./icons/web-icon.svg" alt="web icon">
            </a>
            <a href="https://www.linkedin.com/in/ardisaputra2022" class="w-11 mx-4">
              <img src="./icons/linkedin-icon.svg" alt="linkedin icon">
            </a>
          </div>
        </section>
      </article>
    `;
  }

  _handlerDarkMode() {
    const toogleBtnMode = document.querySelector('#toogle-btn-mode');
    const hadithContainer = this.querySelector('#hadith-container');
    const mode = localStorage.getItem('MODE');
    if (mode && mode === 'dark') {
      hadithContainer.classList.add('bg-slate-800');
    } else {
      hadithContainer.classList.remove('bg-slate-800');
    }
    toogleBtnMode.addEventListener('click', () => {
      hadithContainer.classList.toggle('bg-slate-800');
    });
  }
}

customElements.define('about-page', About);
const about = '<about-page></about-page>';
export default about;
